export const NAV_CONTENT = [
  {
    label: 'Search',
    url: '/uws/ui/index.html'
  }
];



// WEBPACK FOOTER //
// ./src/app/shared/constants/nav-content.js